module.exports = __webpack_public_path__ + "img/trash_del.5177486a.svg";